export const Timer = ({ left, total, label = "Time" }) => {
  const m = Math.floor(left / 60), s = String(left % 60).padStart(2, "0");
  const tone = left <= 5 ? "text-red-500 font-black scale-105" : left < 10 ? "text-amber-500 animate-pulse" : "text-slate-900";
  const pct = total ? (left / total) * 100 : 0;
  return (
    <div className="flex flex-col items-end gap-1" data-testid="item-timer">
      <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-400">{label}</span>
      <span data-testid="item-timer-value" className={`font-mono text-3xl tabular-nums transition-transform ${tone}`}>{m}:{s}</span>
      <div className="h-1 w-28 overflow-hidden rounded-full bg-slate-200">
        <div className={`h-full transition-[width] duration-200 ${left < 10 ? "bg-amber-500" : "bg-indigo-600"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
